import React, { Component } from 'react';
import { connect } from 'react-redux';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
const log = new Logger('APPLICATION_MESSAGES', LOG_LEVELS.DEBUG);

class ApplicationMessagesWrapper extends Component {

  render() {
    log.debug('render(): ', this.props);

    return (
      <>
      {this.props.showMessages &&  <ApplicationMessages 
        messageType={this.props.messageType}
        messageIds={this.props.messageIds}
        excludedMessageIds={this.props.excludedMessageIds}
        scopes={this.props.scopes}
        linkTo={this.props.linkTo}
        tooltipWithParams={this.props.tooltipWithParams}
        tooltipOffset={this.props.tooltipOffset}
        >{this.props.children}</ApplicationMessages>}
      </>
    );
  }
}


ApplicationMessagesWrapper.defaultProps = {
  tooltipWithParams: true
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): ', state, props);
  const inAppMessages = (state.logger && state.logger.inAppMessages) || [];
  const types = props.messageType;
  const scopes = Array.isArray(props.scopes) ? props.scopes : typeof props.scopes === 'string' ? [props.scopes] : undefined;
  const messageIds = Array.isArray(props.messageIds) ? props.messageIds : typeof props.messageIds === 'number' ? [props.messageIds] : undefined;
  const excludedMessageIds = Array.isArray(props.excludedMessageIds) ? props.excludedMessageIds : typeof props.excludedMessageIds === 'number' ? [props.excludedMessageIds] : undefined;

  const showMessages = inAppMessages.some((entry) => {
    return entry.message && (!types || types.indexOf(entry.message.type) >=0 ) 
            && (!scopes || scopes.indexOf(entry.scope) >= 0) 
            && (!messageIds || messageIds.indexOf(entry.message.id) >=0)
            && (!excludedMessageIds || excludedMessageIds.indexOf(entry.message.id) === -1);
  });

  return {
    showMessages : showMessages
  };
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(ApplicationMessagesWrapper);